import { render, staticRenderFns } from "./BxBox.vue?vue&type=template&id=2300252a&"
import script from "./BxBox.vue?vue&type=script&lang=js&"
export * from "./BxBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports